import { useParams } from "react-router-dom";
import { usePublicShop } from "../queries/use-public-shop";

export type WidgetParams = {
  shopId: string;
  shopInternalId: string;
  orderId: string;
  shopSlug: string;
  isRetractionPortal: boolean;
  returnRequestId?: string;
  logoUrl: string | null;
};

export function useWidgetParams(): WidgetParams {
  const { shopId, orderId, returnRequestId } = useParams();

  if (!shopId) throw new Error("shopId is required in URL params");
  if (!orderId) throw new Error("orderId is required in URL params");

  const { data: shop } = usePublicShop(shopId);

  return {
    shopId,
    shopInternalId: shop._id,
    orderId,
    shopSlug: shop.slug,
    isRetractionPortal: !!shop.plan?.retractionPortal,
    returnRequestId,
    logoUrl: shop.logoUrl ?? null,
  };
}
